<template>
    <div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" id="search" dark rounded color="primary" @click="initComponent">
                    <span class="marginSpan"> Gerar Excel </span>
                </v-btn>
            </template>
        </v-tooltip>
        
        <v-dialog :persistent="persistent" v-model="dialog" width="500">
            <v-card raised style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
                <v-toolbar flat>
                    <v-toolbar-title >{{ tituloTela }}</v-toolbar-title>
                </v-toolbar>

                <v-card-text pa-0 ma-0>
                    <v-layout row justify-center>
                        <v-flex class="item" xs11 md11>
                            <v-text-field :rules="[campoEmail]" v-model.number="dsEmail"
                                label="Email para envio" outlined clearable>
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                
                <v-layout ma-0 pa-2 pr-5 pl-5 >
                    <v-layout row wrap justify-start>
                        <v-btn id="cancel" rounded @click="cancel" style="background-color:#e8e8e8;"> 
                            <span  class="marginSpan"> Cancelar </span>
                            <v-icon small>fa-times</v-icon>
                        </v-btn>
                    </v-layout>
                    <v-layout row wrap justify-end>
                        <v-btn id="saveRegistro" dark rounded color="primary" @click="saveRegistro">
                            <span class="marginSpan"> Confirmar </span>
                            <v-icon dark small>fa-save</v-icon>
                        </v-btn>
                    </v-layout>
                </v-layout>
            </v-card>
        </v-dialog>
    </div>

    
    
</template>

<script>
    import { campoEmail } from '@/filters/rules'
    import AppMainDialogForm from '@/components/layout/AppMainDialogForm.vue'
    import AppLoaderBlockCard from '@/components/layout/AppLoaderBlockCard.vue'

    import { mask } from 'vue-the-mask'

    export default {
        components: {
            AppLoaderBlockCard,
            AppMainDialogForm,
        },
        directives: {
            mask,
        },
        data () {
            return {
                tooltip: 'Informar email para envio',
                tituloTela: 'Informar email para envio',
                dsEmail: '',
                persistent: true
            }
        },
        methods: {
            campoEmail,
            initComponent() {
                this.dsEmail = ''
                this.$emit('openDialog')
            },
            saveRegistro() {
                this.$emit('inserted', this.dsEmail)
            },
            cancel() {
                this.$emit('closeDialog')
            }
        },
        props: {
            dialog: {
                type: Boolean,
                default: false
            },
            peso: {
                type: Number,
                default: 0
            }
        },
        watch: {
            'dialog' (newValue, oldValue) {
                if (newValue && !oldValue)
                {
                    this.initComponent()
                }
            }
        }
    }
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
